import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';

export function getLastYearWithValues(data: any, standortTid: any): number {
    const kennzahlen: any = standortTid
        ? (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standortTid] || {}
        : data[IDs.KENNZIFFERN_BERECHNET] || {};
    const konfig = data[IDs.ENT_KONFIGURATION];
    const jahrMax = Moment().year();
    let jahrMin = 2010;

    if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
        jahrMin = konfig[0].startjahr_datenerfassung;
    }
    let jahr = jahrMax;
    while (jahr >= jahrMin) {
        const kz = kennzahlen[jahr] || {};
        const co2_total = kz.co2_fussabdruck_total;
        if (co2_total) {
            break;
        } else {
            jahr--;
        }
    }
    if (jahr === jahrMin) {
        return null;
    }
    return jahr;
}
